<template>
  <div class="verified">
    <div class="logo">
        <img src="https://fr-static.shopshops.top/20220630/logo_Shopshops.a782270690da1bb5.png" alt="">
    </div>
    <div class="content" v-if="isVerified">
        <div class="title">You're Verified!</div>
        <p>You won't need to do this again. Information about any ShopShops orders will be sent to you at this email address. You may close the window now.</p>
    </div>
    <div class="content" v-else>
        <div class="title">Oops,</div>
        <p>looks like this link has expired. Please try to verify your email address again in the ShopShops app when you checkout.</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        isVerified: true
    }
  },
  created() {
    this.isVerified = !!this.$route.query.verified
  }
}
</script>

<style lang="less" scoped>
.verified{
    background-color: #fbf8ed;
    height: 100vh;
    max-width: 600px;
    margin: 0 auto;
    .logo{
        background: #000000;
        padding: 10px 0;
        img{
            width: 50px;
            vertical-align: top;
        }
    }
    .content{
        padding: 60px 0px;
        .title{
            font-size: 28px;
            font-weight: 700;
        }
        p{
            font-size: 18px;
            line-height: 28px;
            padding: 40px;
        }
    }
}
</style>
